// SOURCE UNIQUE DE VÉRITÉ des métadonnées SEO (Bloc G1).
// Objet JavaScript pur, sans dépendance à aucune API de plateforme.
// Le composant React <Seo> ET (le jour venu) toute couche serveur/pré-rendu
// doivent lire CE fichier, pour qu'il soit impossible que client et serveur
// se contredisent.
//
// SITE_URL = domaine CANONIQUE public, lu depuis l'environnement (source unique).
// Ce n'est pas une URL d'API (l'API passe par REACT_APP_BACKEND_URL ailleurs).
export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://viralya.io";

// Image de partage par défaut (1200x630), servie depuis le domaine du site.
export const DEFAULT_OG_IMAGE = SITE_URL + "/img/og-image.jpg";

// Chaînes EXACTES du Bloc G1, au caractère près. Ne pas reformuler.
export const ROUTES_META = {
  "/": {
    title: "Influenceur IA : le commercial qui publie, répond et vend 24h/24 | VIRALYA",
    description:
      "VIRALYA crée votre influenceur IA : il publie chaque jour, répond aux DM et envoie vos leads chauds vers vos pages de vente ou de rendez-vous. Dès 197 CHF/mois, en Suisse.",
  },
  "/prix": {
    title: "Prix et tarifs — gestion de réseaux sociaux en Suisse | VIRALYA",
    description:
      "Quatre plans de 197 à 3 497 CHF par mois, le coût par contenu, et la comparaison avec un community manager interne à 7 130 CHF charges comprises.",
  },
  "/cout-community-manager-suisse": {
    title: "Combien coûte un community manager en Suisse ? | VIRALYA",
    description:
      "41 h 20 par semaine, 7 130 CHF par mois charges comprises : le calcul détaillé fonction par fonction, et les trois alternatives comparées.",
  },
  "/pilote": {
    title: "Pilote 7 jours — 49 CHF | VIRALYA",
    description:
      "Sept jours pour voir votre personnage IA publier et répondre. Paiement unique de 49 CHF, sans abonnement et sans reconduction automatique.",
  },
  "/audit": {
    title: "Audit de votre présence sur les réseaux sociaux | VIRALYA",
    description:
      "Vingt minutes, sans carte bancaire et sans appel de vente déguisé. Vous recevez un document écrit, même si vous ne signez pas.",
  },
  "/agences": {
    title: "Offre agences et revendeurs — marque blanche | VIRALYA",
    description:
      "Votre coût de production, pas votre prix de vente. Calculez votre marge selon votre nombre de clients et votre propre tarif.",
  },
  "/affiliation": {
    title: "Programme d'affiliation | VIRALYA",
    description:
      "Recommandez VIRALYA à votre audience et gagnez une commission de 15 %. Candidature en quelques minutes, réponse sous 48 h ouvrées.",
  },
  "/journal": {
    title: "Journal — méthode, intégrations et preuves | VIRALYA",
    description:
      "Comment VIRALYA produit, ce à quoi nous sommes connectés (CRM, relances) et ce que nous pouvons prouver. Pas de veille d'actualité.",
  },
  "/journal/dm-centralises-loomy-crm": {
    title: "Du DM au client : où s'arrête Viralya, où commence Loomy CRM | VIRALYA",
    description:
      "Viralya attire et chauffe vos leads sur 4 plateformes ; dès qu'un lead est prêt à être converti, Loomy CRM prend le relais pour la vente (conversion, rendez-vous closer, suivi).",
  },
  "/journal/relance-leads-par-appel-talk-flow": {
    title: "Le DM chauffe, l'appel conclut : relances par appel avec Talk-Flow | VIRALYA",
    description:
      "Un lead qualifié qui ne répond plus ? Un agent vocal Talk-Flow le rappelle, le requalifie et pose le rendez-vous — jusqu'à la vente, dès 97 CHF/mois.",
  },
  "/journal/machine-derriere-viralya": {
    title: "La machine derrière Viralya : qui a construit notre acquisition ? | VIRALYA",
    description:
      "Plateforme, site, SEO, tunnel, campagnes : l'infrastructure complète de VIRALYA a été construite par Darven, qui gère aussi notre acquisition client.",
  },
  "/o/ecommerce": {
    title: "Réseaux sociaux pour e-commerce en Suisse romande | VIRALYA",
    description:
      "Votre catalogue devient un flux de vidéos courtes publiées tous les jours, sans tournage et sans montage.",
  },
  "/o/infopreneur": {
    title: "Réseaux sociaux pour infopreneurs et formateurs | VIRALYA",
    description:
      "Votre expertise devient un flux de contenus quotidiens et de lives qui remplissent vos formations, sans tournage ni montage.",
  },
  "/o/agence": {
    title: "Contenu en marque blanche pour agences | VIRALYA",
    description:
      "Un influenceur IA par client, publié en continu sur chaque compte, sans staffer de monteurs ni de community managers.",
  },
  "/o/freelance": {
    title: "Réseaux sociaux pour indépendants et freelances | VIRALYA",
    description:
      "Un influenceur IA qui publie et prospecte à votre place pendant que vous livrez vos missions clients.",
  },
  "/demonstration": {
    title: "Démonstration — la machine au travail, sans coupe | VIRALYA",
    description:
      "Neuf minutes de production réelle, sans montage et sans accéléré, défauts compris.",
  },
  "/cercle-fondateurs": {
    title: "Cercle Fondateurs — 20 places | VIRALYA",
    description:
      "Trente pour cent de réduction à vie, en échange d'un témoignage signé après soixante jours et du droit de citer vos chiffres.",
  },
  "/compteur": {
    title: "Places attribuées — le compteur | VIRALYA",
    description:
      "Mis à jour à la main sous 24 heures ouvrables après chaque souscription confirmée. Aucune horloge ne tourne sur cette page.",
  },
  "/legal/mentions": {
    title: "Mentions légales | VIRALYA",
    description: "Éditeur, hébergement, responsabilité et coordonnées de contact.",
  },
  "/legal/confidentialite": {
    title: "Protection des données (LPD / nLPD) | VIRALYA",
    description:
      "Quelles données sont collectées, pourquoi, où elles sont hébergées, et comment exercer vos droits.",
  },
  "/legal/cgv": {
    title: "Conditions générales de vente | VIRALYA",
    description:
      "Prestations, durée, facturation, résiliation et limites de responsabilité.",
  },
  "/legal/sous-traitants": {
    title: "Sous-traitants et hébergement des données | VIRALYA",
    description:
      "Liste nominative des sous-traitants, nature des traitements et pays d'hébergement.",
  },
  "/legal/cookies": {
    title: "Cookies et consentement | VIRALYA",
    description:
      "Quels cookies sont posés, à quel moment, et comment retirer son consentement.",
  },
  "/legal/transparence-ia": {
    title: "Transparence sur l'intelligence artificielle | VIRALYA",
    description:
      "Comment les personnages sont signalés comme IA sur chaque plateforme, et ce que nous ne faisons pas.",
  },
};

// Normalise un chemin : retire le slash final (sauf racine), enlève la query/hash.
function normalizePath(path) {
  if (!path) return "/";
  let p = String(path).split("?")[0].split("#")[0];
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p || "/";
}

// Clé utilisée pour les surcharges SEO éditables en admin (grossière, par famille).
function overrideKey(key) {
  if (key.startsWith("/legal")) return "/legal";
  if (key.startsWith("/o/")) return "/o";
  return key;
}

// Résout les métadonnées d'un chemin.
// - Route publiée connue -> ses chaînes exactes, indexable.
// - Chemin inconnu (hors des 16) -> title/description null (la page fournit
//   son propre libellé si besoin) + noindex = true (périmètre : seules les
//   16 routes sont indexables).
export function getRouteMeta(path) {
  const key = normalizePath(path);
  const canonical = SITE_URL + (key === "/" ? "" : key);
  const m = ROUTES_META[key];
  if (m) {
    return {
      key,
      title: m.title,
      description: m.description,
      ogTitle: m.ogTitle || m.title,
      ogDescription: m.ogDescription || m.description,
      ogImage: m.ogImage || DEFAULT_OG_IMAGE,
      canonical,
      noindex: false,
      matchKey: overrideKey(key),
    };
  }
  return {
    key,
    title: null,
    description: null,
    ogTitle: null,
    ogDescription: null,
    ogImage: DEFAULT_OG_IMAGE,
    canonical,
    noindex: true,
    matchKey: overrideKey(key),
  };
}

// Liste des routes publiées et indexables (pour sitemap / vérifs).
export const PUBLISHED_ROUTES = Object.keys(ROUTES_META);
